module.exports = __webpack_public_path__ + "static/img/deploy0.aaa30ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/deploy0.png
// module id = K5X3
// module chunks = 1